var getPrototypeOf = require("./getPrototypeOf");

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/superPropBase.js
// module id = /1gr
// module chunks = 0